module.exports = function() {
  return new Worker(__webpack_public_path__ + "9642e142271a38e16f7a.worker.js");
};